import { NavLink } from "react-router-dom";
import { navItems } from "@/data/navigation";

export const NavLinks = ({ user }) => (
  <>
    {navItems.filter((item) => !item.adminOnly || user?.is_admin).map((item) => {
      const Icon = item.icon;
      return (
        <NavLink
          key={item.to}
          to={item.to}
          data-testid={item.testId}
          className={({ isActive }) =>
            `inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 ${
              isActive ? "bg-[#1A3626] text-white" : "text-[#4A5D4E] hover:bg-white hover:text-[#1A3626]"
            }`
          }
        >
          <Icon size={16} />
          {item.label}
        </NavLink>
      );
    })}
  </>
);